// Formattazione condivisa dai componenti della dashboard e dal report
const currency = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const currencyCents = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
const number = new Intl.NumberFormat('it-IT');

export const formatEur = value => currency.format(+value || 0);
export const formatEurCents = value => currencyCents.format(+value || 0);
export const formatNumber = value => number.format(+value || 0);
export const formatPct = value => (value === null || value === undefined ? 'n.d.' : `${String(value).replace('.', ',')}%`);

export const formatDelta = value => {
	if (value === null || value === undefined) return 'nuovo';
	const sign = value > 0 ? '+' : '';
	return `${sign}${String(value).replace('.', ',')}%`;
};

// inverse: per indicatori dove scendere e' positivo (es. tasso resi)
export const deltaColor = (value, inverse = false) => {
	if (value === null || value === undefined || value === 0) return 'grey';
	const good = inverse ? value < 0 : value > 0;
	return good ? 'success' : 'error';
};

export const MONTHS = Array.from({ length: 12 }, (_, i) => {
	const name = new Date(2020, i, 1).toLocaleString('it-IT', { month: 'long' });
	return { value: i + 1, text: name.charAt(0).toUpperCase() + name.slice(1) };
});

// Etichetta breve di un bucket 'YYYY-MM-DD' o 'YYYY-MM'
export const bucketLabel = bucket => {
	if (!bucket) return '';
	const [y, m, d] = bucket.split('-');
	if (d) return `${+d}/${+m}`;
	return `${MONTHS[+m - 1].text.slice(0, 3)} ${y.slice(2)}`;
};

// Colori fissi per canale, cosi' ogni piattaforma ha sempre lo stesso colore in tutti i grafici
const PALETTE = ['#1976D2', '#FF9800', '#43A047', '#8E24AA', '#E53935', '#00ACC1', '#6D4C41', '#546E7A', '#C0CA33', '#F06292'];
const KNOWN = { Store: 0, Amazon: 1, Ebay: 2, eBay: 2, Shopify: 3, Magento: 4, Woocommerce: 5, Prestashop: 6, Aliexpress: 7 };

export const platformColor = (name, index = 0) => PALETTE[KNOWN[name] !== undefined ? KNOWN[name] : (index + 8) % PALETTE.length];
